import React from "react";
import { useNavigate } from "react-router-dom";

function CardNews({ news }) {
  const navigate = useNavigate(); // Instancia o hook useNavigate

  const showPostDate = (postDate) => {
    const year = postDate.substring(0, 4);
    const month = postDate.substring(5, 7) - 1;
    const day = postDate.substring(8, 10);
    return new Date(year, month, day).toLocaleDateString("pt-BR");
  }

  return (
    <div className="bg-gray-100 rounded-2xl shadow-lg p-4 mb-4 flex flex-col lg:flex-row items-center lg:items-start">
      {/* Imagem acima no mobile e à esquerda em telas maiores */}
      <div className="w-full lg:w-48 lg:h-48 mb-4 lg:mb-0">
        <img
          src={news.file.url}
          alt={news.title}
          className="w-full h-full object-cover rounded-md"
        />
      </div>

      {/* Conteúdo centralizado no mobile e alinhado à esquerda em telas maiores */}
      <div className="text-center lg:text-left lg:ml-4 flex-1">
        <a
          href="#"
          className="text-2xl font-bold text-blue-950 mb-2 block hover:underline"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/noticias/${news.ID}`);
          }}
        >
          {news.title}
        </a>
        <p className="text-sm text-gray-500 mb-2">
          {showPostDate(news.postDate)} |{" "}
          {news.category.name || "Sem Categoria"}
        </p>
        <p className="text-gray-700 mb-4" dangerouslySetInnerHTML={{ __html: news.content.substring(0, 150) + "..." }} />
        <button
          onClick={() => navigate(`/noticias/${news.ID}`)} // Use o navigate instanciado
          className="mt-2 bg-blue-500 text-sm font-bold text-white px-4 py-2 rounded-md hover:bg-blue-600"
        >
          Leia mais
        </button>
      </div>
    </div>
  );
}

export default CardNews;
